<script>
import { onMounted, ref, computed, inject } from "vue";
import { goToConsulting } from "@/use/utilities/goToConsulting";
import { show as showTestWorkQueue } from "@/use/repositories/testWorkQueue/show";

import Spinner from "@/components/general/Spinner";
import PhaseState from "@/components/History/PhaseState.vue";

export default {
  name: "RenderFeedbackAndNotes",
  components: { Spinner, PhaseState },
  props: {
    data: { type: Object, required: true },
  },
  setup(props) {
    const phases = ref([]);
    const showSpinner = ref(false);
    const { states, departments } = inject("constants");

    const filterStatesWithNotes = (phase) => {
      return phase.states.filter(state => {
        const hasNotes = state.pivot.feedback_notes.length;
        const isNegativeFeedback = state.slug === states.NEGATIVE_FEEDBACK;
        const isCompleted = state.slug === states.COMPLETED;

        if (isCompleted) {
          return hasNotes && phase.internal_phase?.slug === departments.PROGETTAZIONE;
        }

        return hasNotes && isNegativeFeedback;
      });
    };

    const loadPhaseData = async () => {
      showSpinner.value = true;

      try {
        const { testWorkQueue } = await showTestWorkQueue(
          props.data.test_work_queue_id,
          "with_feedbacks_history"
        );
        phases.value = testWorkQueue.test_work_queue_phases;
      } catch (error) {
        console.error(error);
      } finally {
        showSpinner.value = false;
      }
    };

    const filteredPhases = computed(() =>
      phases.value
        .map(phase => {
          const filteredStates = filterStatesWithNotes(phase).reverse();
          return {
            ...phase,
            states: filteredStates,
          };
        })
        .filter(phase => phase.states.length)
        .reverse()
    );

    onMounted(loadPhaseData);

    return { goToConsulting, showSpinner, filteredPhases };
  },
};
</script>

<template>
  <div class="p-4">
    <Spinner v-if="showSpinner" width="100" />
    <div v-else-if="filteredPhases.length" class="phases-container">
      <h3
        class="mb-3 d-flex align-items-center justify-content-center text-violet-dark cp"
        @click="goToConsulting(data.prescription_id, true)"
      >
        <span class="me-1">{{ data.assets[0].number_text }}</span>
        <img :src="require(`@/assets/icons/external-link-violet.svg`)" width="25" />
      </h3>
      <template v-for="phase in filteredPhases" :key="phase.id">
        <PhaseState
          v-for="(state, index) in phase.states"
          :key="index"
          :phase="phase"
          :state="state"
        />
      </template>
    </div>
    <div v-else class="m-auto">{{ $t("No notes present") }}</div>
  </div>
</template>

<style scoped>
.phases-container {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
